import React, { useEffect, useState } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form} from 'react-bootstrap';
import * as Icon from 'react-feather';
import { CONFIG_VEHICULAR_OPTIONS, SUBTIPO_REM_OPTIONS, configRequiresTrailer } from '../unitCatalogs';

const getEquipmentRole = (unit) => {
    if (unit?.equipment_role === 'trailer' || unit?.inventory_type === 'Remolque') {
        return 'trailer';
    }
    return 'power_unit';
};

function DefaultModal(props) {
    const authHeader = useAuthHeader();
        const unit = props.data;
        const [equipmentRole, setEquipmentRole] = useState(getEquipmentRole(props.data));
        const [configVehicular, setConfigVehicular] = useState(props.data.config_vehicular || '');

        const apiUrl = process.env.REACT_APP_URL;

        useEffect(() => {
            if (props.show) {
                setEquipmentRole(getEquipmentRole(unit));
                setConfigVehicular(unit.config_vehicular || '');
            }
        }, [props.show, unit]);

        const handleButtonClick = (event) => {
            event.preventDefault();
            const isTrailer = equipmentRole === 'trailer';
            const data = {
                'id': props.data.id,
                'name': event.target.name.value,
                'plates': event.target.plates.value,
                'inventory_type': isTrailer ? 'Remolque' : 'Autotransporte',
                'equipment_role': equipmentRole,
                'requires_trailer': configRequiresTrailer(event.target.config_vehicular?.value),
                'subtipo_rem': event.target.subtipo_rem?.value || null,
                'make': event.target.make.value,
                'axles': event.target.axles.value,
                'model': event.target.model.value,
                'year': event.target.year.value,
                'config_vehicular': isTrailer ? null : event.target.config_vehicular?.value || null,
                'peso_bruto_vehicular': parseFloat(event.target.peso_bruto_vehicular?.value) || null,
                'permiso_sct': event.target.permiso_sct?.value || null,
                'num_permiso_sct': event.target.num_permiso_sct?.value || null,
                'aseguradora_resp_civil': event.target.aseguradora_resp_civil?.value || null,
                'poliza_resp_civil': event.target.poliza_resp_civil?.value || null}
            axios({
                method:'PUT',
                url:apiUrl+'/units/unit',
            headers: {
                Authorization: authHeader()
            },
                data: data
            }).then(response => {
                console.log(response);
                props.onHide();
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
        }
        return (
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Editar Unidad
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Form key={props.data.id} onSubmit={handleButtonClick}>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="name">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control defaultValue={props.data.name} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="plates">
                                    <Form.Label>Placa</Form.Label>
                                    <Form.Control defaultValue={props.data.plates} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="equipment_role">
                                    <Form.Label>Tipo de Equipo</Form.Label>
                                    <Form.Select
                                        value={equipmentRole}
                                        onChange={(event) => {
                                            const value = event.target.value;
                                            setEquipmentRole(value);
                                            if (value === 'trailer') {
                                                setConfigVehicular('');
                                            }
                                        }}
                                    >
                                        <option value="power_unit">Autotransporte</option>
                                        <option value="trailer">Remolque</option>
                                    </Form.Select>
                                </Form.Group>
                                {equipmentRole === 'trailer' && (
                                    <Form.Group as={Col} controlId="subtipo_rem">
                                        <Form.Label>Subtipo de Remolque</Form.Label>
                                        <Form.Select defaultValue={props.data.subtipo_rem || ""}>
                                            <option value="">Seleccionar...</option>
                                            {SUBTIPO_REM_OPTIONS.map(([value, label]) => (
                                                <option key={value} value={value}>{label}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                )}
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="make">
                                    <Form.Label>Marca</Form.Label>
                                    <Form.Control defaultValue={props.data.make} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="model">
                                    <Form.Label>Modelo</Form.Label>
                                    <Form.Control defaultValue={props.data.model} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="year">
                                    <Form.Label>Año</Form.Label>
                                    <Form.Control defaultValue={props.data.year} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="axles">
                                    <Form.Label>Ejes</Form.Label>
                                    <Form.Control defaultValue={props.data.axles} />
                                </Form.Group>
                            </Row>
                            {equipmentRole !== 'trailer' && (
                            <>
                            <Row className="mb-3">
                                <h6>SAT / Carta Porte</h6>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="config_vehicular">
                                    <Form.Label>Configuración Vehicular</Form.Label>
                                    <Form.Select
                                        value={configVehicular}
                                        onChange={(event) => setConfigVehicular(event.target.value)}
                                    >
                                        <option value="">Seleccionar...</option>
                                        {CONFIG_VEHICULAR_OPTIONS.map(([value, label]) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                    </Form.Select>
                                    {configRequiresTrailer(configVehicular) && (
                                        <Form.Text>Esta configuración requiere seleccionar remolque en el viaje.</Form.Text>
                                    )}
                                </Form.Group>
                                <Form.Group as={Col} controlId="peso_bruto_vehicular">
                                    <Form.Label>Peso Bruto Vehicular (Ton)</Form.Label>
                                    <Form.Control type="number" step="0.01" min="0" placeholder="0.00" defaultValue={props.data.peso_bruto_vehicular || ""} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="permiso_sct">
                                    <Form.Label>Tipo de Permiso</Form.Label>
                                    <Form.Select defaultValue={props.data.permiso_sct || ""}>
                                        <option value="">Seleccionar...</option>
                                        <option value="TPAF01">TPAF01 - Autotransporte Federal de carga general</option>
                                        <option value="TPAF02">TPAF02 - Transporte privado de carga</option>
                                        <option value="TPAF03">TPAF03 - Carga Especializada de materiales peligrosos</option>
                                        <option value="TPAF04">TPAF04 - Transporte de carga de uso exclusivo</option>
                                        <option value="TPAF09">TPAF09 - Doblemente Articulado</option>
                                        <option value="TPAF19">TPAF19 - Servicio de Paquetería y Mensajería</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="num_permiso_sct">
                                    <Form.Label>Número de Permiso</Form.Label>
                                    <Form.Control placeholder="Número de permiso SCT" defaultValue={props.data.num_permiso_sct || ""} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="aseguradora_resp_civil">
                                    <Form.Label>Aseguradora Resp. Civil</Form.Label>
                                    <Form.Control placeholder="Nombre de la aseguradora" defaultValue={props.data.aseguradora_resp_civil || ""} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="poliza_resp_civil">
                                    <Form.Label>Póliza Resp. Civil</Form.Label>
                                    <Form.Control placeholder="Número de póliza" defaultValue={props.data.poliza_resp_civil || ""} />
                                </Form.Group>
                            </Row>
                            </>
                            )}
                            <Button type="submit" value="Submit">Guardar</Button>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_unit = () => {this.props.setData(); this.setState({ modalShow: false });}
        return (
            <ButtonToolbar>
                <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    <Icon.Edit size={14} />
                </Button>
                <DefaultModal show={this.state.modalShow} onHide={add_new_unit} data={this.props.unitInfo}/>
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
